module.exports = __webpack_public_path__ + "img/all_teeth2.6b1ff8fa.png";